module.exports = __webpack_public_path__ + "static/media/microdureza.0fad65db.png";